import React from "react";
import { Button, Col, Container, Row } from "reactstrap";
import WhyOroFirst from "../assets/svgs/WhyOroFirst";
import WhyOroSecond from "../assets/svgs/WhyOroSecond";
import WhyOroThird from "../assets/svgs/WhyOroThird";
import WhyOroFourth from "../assets/svgs/WhyOroFourth";
import WhyOroFifth from "../assets/svgs/WhyOroFifth";
import WhyOroSixth from "../assets/svgs/WhyOroSixth";


export default function WhyInvestNavi(props) {
  const redirectToNavi = () => {
     window.location.href = `/biddeasy/${props.productDetails.product}/#issue`;
  }

  const downloadProspectus = () => {
    window.open(
      props.productDetails.prospectusLink,
      "_blank",
      "noopener"
    );
  }

  // const determineImage = (index) => {
  //   switch (index) {
  //     case 1:
  //       return <WhyOroFirst />;
  //     case 2:
  //       return <WhyOroSecond />;
  //     case 3:
  //       return <WhyOroThird />;
  //     case 4:
  //       return <WhyOroFourth />;
  //     case 5:
  //       return <WhyOroFifth />;
  //     case 6:
  //       return <WhyOroSixth />;
  //     default:
  //       return null;
  //   }
  // }

  const determineImage = (index) => {
    switch (index) {
      case 1:
        return <img src={process.env.REACT_APP_IMAGES_PATH + "Investors.webp"}/>;
      case 2:
        return <img src={process.env.REACT_APP_IMAGES_PATH + "Diversified-Borrowing.webp"}/>;
      case 3:
        return <img src={process.env.REACT_APP_IMAGES_PATH + "User.webp"}/>;
      case 4:
        return <img src={process.env.REACT_APP_IMAGES_PATH + "capitalization.webp"}/>;
      case 5:
        return <img src={process.env.REACT_APP_IMAGES_PATH + "div-port.webp"}/>;
      case 6:
        return <img src={process.env.REACT_APP_IMAGES_PATH + "Growth.webp"}/>;
      default:
        return null;
    }
  }

    return Object.keys(props.productDetails).length && (
      <div className="why-navi-main">
        <Container className="why-navi-sub-main">
          <p className="main-title text-center">
            What we like about { props?.productDetails?.productName ? props?.productDetails?.productName : "NA" }
          </p>
          <Row className="mx-0">
            {props.productDetails &&
            props.productDetails.whyInvest &&
            props.productDetails.whyInvest.split('|').map((item, index) => (
              <Col className="why-navi-item" key={index}>
                {determineImage(index + 1)}
                <p
                  className="mb-0"
                  dangerouslySetInnerHTML={
                    {__html: item}
                  }
                />
              </Col>
          ))}
          </Row>

          {!props.isAsset && <Col lg={10} className="last">
                {!props.isOrobonds ? <Button onClick={redirectToNavi}>
                  Know more about the issue
                </Button> : ''}
                <Button onClick={downloadProspectus}>
                  {!props.isOrobonds ?'Download Prospectus' : 'Know more about the issue'}
                </Button>
            </Col>}
        </Container>
      </div>
    );
  }

  